import { Component, Input } from '@angular/core';
import config from 'passcode-config.json';
import { Student } from '../data/student';

@Component({
  selector: 'app-passcode',
  templateUrl: './passcode.component.html',
  styleUrls: ['./passcode.component.scss']
})
export class PasscodeComponent {

  @Input() size: string;
  @Input() passcode: string;
  constructor() { }

  getSizeClass() {
    return this.size === 'mini' ? 'mini' : '';
  }

  getPasscodeColorClass(student: Student): string {
    return config.colors[this.passcode[1]];
  }

  getPasscodeShapeUrl(student: Student): string {
    return `/assets/shapes/${config.shapes[parseInt(this.passcode[0])]}.svg`;
  }

  getPasscodePictureUrl(student: Student): string {
    return `/assets/pictures/${config.pictures[parseInt(this.passcode[2])]}.svg`;
  }

}
